module.exports = __webpack_public_path__ + "static/media/dryClean.b5d404fa.svg";